import Component from '@glimmer/component';

import { Input } from '@ember/component';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import autofocus from 'ember-autofocus-modifier/modifiers/autofocus';
import stopPropagation from 'ember-event-helpers/helpers/stop-propagation';

import ClearButton from 'rise-ui/components/clear-button.gjs';
import classMod from 'rise-ui/helpers/class-mod.js';
import event from 'rise-ui/helpers/event.js';
import fnx from 'rise-ui/helpers/fnx.js';
import nom from 'rise-ui/helpers/nom.js';
import not from 'rise-ui/helpers/not.js';
import { call } from 'rise-ui/utils/function.js';

export default class QuickFilterComponent extends Component {
  @tracked value;

  get classModifiers() {
    return [ this.value, '--dirty' ];
  }

  @action doFilter(value) {
    this.value = value;
    call(this.args.action, null, value);
  }

  <template>
    <span
      class={{classMod "c-quick-filter" modifiers=this.classModifiers}}
      ...attributes
    >{{nom~}}
      <Input aria-label="Quick Filter"
        class={{classMod "c-quick-filter__input" modifiers=this.classModifiers}}
        placeholder="Quick Filter"
        @value={{this.value}}
        @escape-press={{fnx this.doFilter noMoreArgs=true}}
        {{autofocus disabled=(not @autofocus)}}
        {{on "click" (stopPropagation)}}
        {{on "input" (event this.doFilter)}}
      />{{nom~}}
      <ClearButton
        @class="c-quick-filter__clear"
        @disabled={{not this.value}}
        @action={{fnx this.doFilter noMoreArgs=true}}
      />{{nom~}}
    </span>
  </template>
}
